import DgTransfer from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTransfer.install = function (Vue) {
  Vue.component(DgTransfer.name, DgTransfer)
}
export default DgTransfer

export { DgTransfer }